import { jsx } from 'react/jsx-runtime';

const SvgArrowBranch = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M11 5 9 3H3v6l2 2V6.41l6 6V21h2v-9.41L6.41 5H11ZM15 3l-2 2h4.59l-4.3 4.29 1.42 1.42L19 6.41V11l2-2V3h-6Z" }) }));

export { SvgArrowBranch as default };
//# sourceMappingURL=ArrowBranch.es.js.map
